import React, { Component } from 'react';

const fmt = (val) => {
  const num = Math.round(Number(val) * 100) / 100;
  if (isNaN(num)) return '';
  const [int, dec] = num.toString().split('.');
  const intFmt = int.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return dec ? `${intFmt},${dec.padEnd(2, '0')}` : intFmt;
};

const parse = (str) =>
  Number(String(str).replace(/\./g, '').replace(',', '.')) || 0;

class RangeInput extends Component {

  constructor(props) {
    super(props);
    const { value, minValue, minPrice, maxPrice } = props;
    const min = minPrice || 0;
    const max = maxPrice || 0;
    this.state = {
      minInputVal: Math.round((minValue > 0 ? minValue : min) * 100) / 100,
      maxInputVal: Math.round((value > 0 ? value : max) * 100) / 100,
    };
    this.minRangeRef = React.createRef();
    this.maxRangeRef = React.createRef();
    this.fillRef = React.createRef();
    this.minNumRef = React.createRef();
    this.maxNumRef = React.createRef();
    this._commitMin = this._commitMin.bind(this);
    this._commitMax = this._commitMax.bind(this);
  }

  componentDidMount() {
    this._syncVisuals(this.state.minInputVal, this.state.maxInputVal);
  }

  componentDidUpdate(prevProps) {
    const { value, minValue, minPrice, maxPrice } = this.props;
    const min = minPrice || 0;
    const max = maxPrice || 0;
    const propsChanged =
      prevProps.value !== value ||
      prevProps.maxPrice !== maxPrice ||
      prevProps.minValue !== minValue ||
      prevProps.minPrice !== minPrice;
    if (propsChanged) {
      const newMin = Math.round((minValue > 0 ? minValue : min) * 100) / 100;
      const newMax = Math.round((value > 0 ? value : max) * 100) / 100;
      this.setState({ minInputVal: newMin, maxInputVal: newMax });
      this._syncVisuals(newMin, newMax);
    }
  }

  _syncVisuals(minVal, maxVal) {
    const min = this.props.minPrice || 0;
    const max = this.props.maxPrice || 0;
    const minRounded = Math.round(minVal * 100) / 100;
    const maxRounded = Math.round(maxVal * 100) / 100;
    if (this.minRangeRef.current) this.minRangeRef.current.value = minRounded;
    if (this.maxRangeRef.current) this.maxRangeRef.current.value = maxRounded;
    if (this.minNumRef.current) this.minNumRef.current.value = fmt(minRounded);
    if (this.maxNumRef.current) this.maxNumRef.current.value = fmt(maxRounded);
    if (this.fillRef.current && max > min) {
      const minPct = ((minVal - min) / (max - min)) * 100;
      const maxPct = ((maxVal - min) / (max - min)) * 100;
      this.fillRef.current.style.left = minPct + '%';
      this.fillRef.current.style.width = (maxPct - minPct) + '%';
    }
  }

  _commitMin() {
    const { id, minPrice, onChange } = this.props;
    const min = minPrice || 0;
    const maxVal = this.maxRangeRef.current ? Number(this.maxRangeRef.current.value) : this.state.maxInputVal;
    const raw = this.minNumRef.current ? parse(this.minNumRef.current.value) : this.state.minInputVal;
    const clamped = Math.round(Math.min(Math.max(raw || min, min), maxVal) * 100) / 100;
    this.setState({ minInputVal: clamped });
    this._syncVisuals(clamped, maxVal);
    onChange(id + 'Min', clamped <= min ? 0 : clamped);
  }

  _commitMax() {
    const { id, maxPrice, onChange } = this.props;
    const max = maxPrice || 0;
    const minVal = this.minRangeRef.current ? Number(this.minRangeRef.current.value) : this.state.minInputVal;
    const raw = this.maxNumRef.current ? parse(this.maxNumRef.current.value) : this.state.maxInputVal;
    const clamped = Math.round(Math.min(Math.max(raw || max, minVal), max) * 100) / 100;
    this.setState({ maxInputVal: clamped });
    this._syncVisuals(minVal, clamped);
    onChange(id, clamped >= max ? 0 : clamped);
  }

  render() {
    const { id, onChange, value, label, maxPrice, minPrice, inputClean } = this.props;
    const { minInputVal, maxInputVal } = this.state;
    //inputClean: return without className by default

    if (inputClean && inputClean.value) {
      return (
        <>
          <label className={inputClean.classNameLabel} htmlFor={id}>
            {inputClean.containLabel}
          </label>
          <input
            type="range"
            className={inputClean.classNameInput}
            id={id}
            onChange={(e) => onChange(e)}
            value={value}
            min={inputClean.minValue}
            max={inputClean.maxValue}
            step={inputClean.step}
          />
        </>
      )
    }

    const min = minPrice || 0;
    const max = maxPrice || 0;
    const minPct = max > min ? ((minInputVal - min) / (max - min)) * 100 : 0;
    const maxPct = max > min ? ((maxInputVal - min) / (max - min)) * 100 : 100;

    return (
      <div>
        {label && <h6 className="mb-0 text-dark">{label}</h6>}
        <div className="dual-range-wrapper">
          <div className="dual-range-track-bg" />
          <div
            ref={this.fillRef}
            className="dual-range-track-fill"
            style={{ left: minPct + '%', width: (maxPct - minPct) + '%' }}
          />
          <input
            ref={this.minRangeRef}
            type="range"
            className="dual-range-input"
            min={min}
            max={max}
            step="any"
            defaultValue={minInputVal}
            style={{ zIndex: 3 }}
            onChange={(e) => {
              const maxVal = Number(this.maxRangeRef.current.value);
              const val = Math.min(Number(e.target.value), maxVal);
              this.minRangeRef.current.value = val;
              this._syncVisuals(val, maxVal);
            }}
            onMouseUp={() => {
              const val = Math.round(Number(this.minRangeRef.current.value) * 100) / 100;
              this.setState({ minInputVal: val });
              onChange(id + 'Min', val <= min ? 0 : val);
            }}
            onTouchEnd={() => {
              const val = Math.round(Number(this.minRangeRef.current.value) * 100) / 100;
              this.setState({ minInputVal: val });
              onChange(id + 'Min', val <= min ? 0 : val);
            }}
          />
          <input
            ref={this.maxRangeRef}
            type="range"
            className="dual-range-input"
            min={min}
            max={max}
            step="any"
            defaultValue={maxInputVal}
            style={{ zIndex: 4 }}
            onChange={(e) => {
              const minVal = Number(this.minRangeRef.current.value);
              const val = Math.max(Number(e.target.value), minVal);
              this.maxRangeRef.current.value = val;
              this._syncVisuals(minVal, val);
            }}
            onMouseUp={() => {
              const val = Math.round(Number(this.maxRangeRef.current.value) * 100) / 100;
              this.setState({ maxInputVal: val });
              onChange(id, val >= max ? 0 : val);
            }}
            onTouchEnd={() => {
              const val = Math.round(Number(this.maxRangeRef.current.value) * 100) / 100;
              this.setState({ maxInputVal: val });
              onChange(id, val >= max ? 0 : val);
            }}
          />
        </div>
        <div className="d-flex align-items-center mt-2">
          <input
            ref={this.minNumRef}
            type="text"
            className="form-control text-center"
            defaultValue={fmt(minInputVal)}
            onBlur={() => this._commitMin()}
            onKeyDown={(e) => e.key === 'Enter' && this._commitMin()}
          />
          <span className="mx-2 text-muted flex-shrink-0">—</span>
          <input
            ref={this.maxNumRef}
            type="text"
            className="form-control text-center"
            defaultValue={fmt(maxInputVal)}
            onBlur={() => this._commitMax()}
            onKeyDown={(e) => e.key === 'Enter' && this._commitMax()}
          />
        </div>
      </div>
    );
  }

}

export default RangeInput;
